import { createAction } from 'redux-act';

import * as profile from '../../core/profile';

export const updateAccount = createAction(
  'update account',
);
export const updateAccountSuccess = createAction(
  'update account success',
);
export const updateAccountFail = createAction(
  'update account fail',
  (error) => error
);

export const updatePassword = createAction(
  'update password',
);
export const updatePasswordSuccess = createAction(
  'update password success',
);
export const updatePasswordFail = createAction(
  'update password fail',
  (error) => error
);

export const updatePublisherCompanyInfo = createAction(
  'update company info',
);
export const updatePublisherCompanyInfoSuccess = createAction(
  'update company info success',
);
export const updatePublisherCompanyInfoFail = createAction(
  'update company info fail',
  (error) => error
);

export const updatePaymentInfo = createAction(
  'update payment info',
);
export const updatePaymentInfoSuccess = createAction(
  'update payment info success',
);
export const updatePaymentInfoFail = createAction(
  'update payment info fail',
  (error) => error
);

export const changeActiveTab = createAction(
  'change active tab',
);

export const reducer = {
  [updateAccountSuccess]: (state, payload) =>
    profile.updateAccountSuccess(state, payload),
  [updatePublisherCompanyInfoSuccess]: (state, payload) =>
    profile.updatePublisherCompanyInfoSuccess(state, payload),
  [updatePaymentInfoSuccess]: (state, payload) =>
    profile.updatePaymentInfoSuccess(state, payload),
  [changeActiveTab]: (state, payload) =>
    profile.changeActiveTab(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/profile.module.js
 **/